import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { moduleActionContext } from '@/store';
const authModule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export const authModuleActionContext = (context) => moduleActionContext(context, authModule);
export default authModule;
